import React, {useState, useCallback} from 'react'
import {DndContext} from '@dnd-kit/core'
import Draggable from './Draggable'
import Hand from './Hand'

let HAND_HEIGHT = 129 // CARD_H (125) + 4

let GameBoard = ({boardCards, hand, onMoveCard, onPlayCard, onPickUpCard, screenWidth, screenHeight}) => {
  let [zoom, setZoom] = useState(1.0)
  let [contextMenu, setContextMenu] = useState(null) // {cardId, x, y}

  let handleWheel = useCallback(e => {
    e.preventDefault()
    setZoom(z => {
      let next = z + (e.deltaY > 0 ? -0.08 : 0.08)
      return Math.min(5, Math.max(0.2, next))
    })
  }, [])

  let handleDragEnd = e => {
    let card = boardCards.find(c => c.id === e.active.id)
    if (!card) return
    let scale = 1 / zoom

    // If dropped in the hand area, pick it up
    let finalY = card.posY + e.delta.y * scale
    let boardHeight = screenHeight - HAND_HEIGHT
    if (e.activatorEvent?.clientY + e.delta.y > boardHeight) {
      onPickUpCard(card.id)
      return
    }

    onMoveCard(card.id, card.posX + e.delta.x * scale, finalY)
  }

  let handleContextMenu = (e, cardId) => {
    e.preventDefault()
    e.stopPropagation()
    setContextMenu({cardId, x: e.clientX, y: e.clientY})
  }

  let closeMenu = () => setContextMenu(null)

  let menuAction = action => {
    if (!contextMenu) return
    if (action === 'pickup') {
      onPickUpCard(contextMenu.cardId)
    }
    if (action === 'flip') {
      // TODO: flip card facedown/faceup
    }
    closeMenu()
  }

  let boardHeight = screenHeight - HAND_HEIGHT

  return (
    <div
      style={{width: screenWidth, height: screenHeight, position: 'relative'}}
      onClick={closeMenu}>
      {/* Board area */}
      <div
        onWheel={handleWheel}
        onContextMenu={e => e.preventDefault()}
        style={{
          width: screenWidth,
          height: boardHeight,
          backgroundColor: '#222',
          position: 'relative',
          overflow: 'hidden',
        }}>
        <div
          style={{
            transform: `scale(${zoom})`,
            transformOrigin: `${screenWidth / 2}px ${boardHeight / 2}px`,
            position: 'relative',
            width: screenWidth,
            height: boardHeight,
          }}>
          {/* Vertical center line */}
          <div
            style={{
              position: 'absolute',
              left: screenWidth / 2,
              top: -10000,
              width: 1,
              height: 20000,
              backgroundColor: '#555',
            }}
          />
          {/* Horizontal center line */}
          <div
            style={{
              position: 'absolute',
              top: boardHeight / 2,
              left: -10000,
              height: 1,
              width: 20000,
              backgroundColor: '#555',
            }}
          />
          <DndContext onDragEnd={handleDragEnd}>
            {boardCards.map(c => (
              <Draggable
                key={c.id}
                id={c.id}
                posX={c.posX}
                posY={c.posY}
                zoom={zoom}
                card={c.card}
                onContextMenu={e => handleContextMenu(e, c.id)}
              />
            ))}
          </DndContext>
        </div>
      </div>

      {/* Context menu */}
      {contextMenu && (
        <div
          style={{
            position: 'fixed',
            top: contextMenu.y,
            left: contextMenu.x,
            zIndex: 50,
            display: 'flex',
            flexDirection: 'column',
          }}>
          {[
            {key: 'pickup', label: 'pick up'},
            {key: 'flip', label: 'flip'},
          ].map((item, i) => (
            <div
              key={item.key}
              onClick={e => {
                e.stopPropagation()
                menuAction(item.key)
              }}
              style={{
                padding: '8px 16px',
                color: '#888',
                fontSize: 13,
                backgroundColor: '#2a2a2a',
                cursor: 'pointer',
                borderBottom: i === 0 ? '1px solid #3a3a3a' : 'none',
                fontFamily: 'Lato, sans-serif',
                fontWeight: 300,
              }}>
              {item.label}
            </div>
          ))}
        </div>
      )}

      {/* Hand area */}
      <Hand
        hand={hand}
        onPlayCard={onPlayCard}
        screenWidth={screenWidth}
        screenHeight={screenHeight}
      />
    </div>
  )
}

export default GameBoard
